module.exports = __webpack_public_path__ + "img/bankcode5.e1f33bc0.png";